<template>
  <v-container class="grey lighten-3 row-container">
    <v-layout row wrap class="pa-3">
      <v-flex xs8 sm9 md4>
        <div>
          <v-text-field
            label="Número de confirmación"
            outlined
            clearable
            hide-details="auto"
            prepend-inner-icon="search"
            :rules="[
              (value) =>
                (value =
                  /^\d+$/.test(value) ||
                  'Un número de confirmación no puede contener letras ni espacios en blanco!'),
            ]"
            v-model="model.pedidoNum"
          >
          </v-text-field>
        </div>
      </v-flex>

      <v-flex xs1 md1 class="prueba">
        <div>
          <v-btn
            x-large
            elevation="10"
            depressed
            color="primary"
            :disabled="loading || !model.pedidoNum.length"
            @click="getPedidoInfocomplemento(model.pedidoNum)"
          >
            <div class="text-xs-h5 text-sm-h5 text-md-h5 text-lg-h4 text-xl-h3">
              Buscar
            </div>
          </v-btn>
        </div>
      </v-flex>

      <v-flex xs12 sm12 md6>
        <div class="text-sm-h4 text-md-h4 text-lg-h4 text-xl-h3 text-center">
          ¿No tienes número de confirmación?
        </div>

        <div class="text-sm-h4 text-md-h5 text-lg-h5 text-xl-h4 text-center">
          Comunícate al 800-6RISOUL (747685)
        </div>

        <div class="text-sm-h4 text-md-h5 text-lg-h5 text-xl-h4 text-center">
          o
          <a href="customercare@risoul.com.mx"> customercare@risoul.com.mx</a>
        </div>
      </v-flex>
    </v-layout>

    <!-- comienza stepper -->
    <v-stepper alt-labels>
      <v-stepper-header>
        <v-stepper-step :complete="paso0" step="1">
          Fecha de pedido
          <v-card-subtitle class="pb-0">{{ pedidoFecha }}</v-card-subtitle>
        </v-stepper-step>

        <v-divider class="dividerStep" :class="{ stepDivide1: paso1 }" />

        <v-stepper-step :complete="paso1" step="2"> En proceso </v-stepper-step>

        <v-divider class="dividerStep" :class="{ stepDivide1: paso2 }" />

        <v-stepper-step :complete="paso2" step="3"> En camino </v-stepper-step>

        <v-divider class="dividerStep" :class="{ stepDivide1: paso3 }" />

        <v-stepper-step :complete="paso3" step="4">
          Entregado
          <v-card-subtitle class="pb-0" v-show="pedidoParcial">
            parcial
          </v-card-subtitle>
        </v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <v-layout row wrap justify-center v-show="loading">
          <v-flex xs12 md12>
            <div class="nextBox text-sm-h5 text-md-h5 text-lg-h5 text-xl-h4">
              Cargando información... Espere un momento por favor..
            </div>
          </v-flex>

          <v-flex xs8 sm6 md6>
            <v-divider></v-divider>

            <v-progress-linear
              slot="progress"
              color="orange"
              :active="loading"
              :indeterminate="loading"
              height="8"
              rounded
              stream
              buffer-value="0"
            >
            </v-progress-linear>

            <v-divider></v-divider>
          </v-flex>
        </v-layout>

        <v-layout row wrap v-show="noDataFound" justify-center>
          <v-flex xs10 md9>
            <div
              class="nextBox text-sm-h5 text-md-h5 text-lg-h5 text-xl-h4 red--text"
            >
              <v-icon small color="red" class="pa-3">report_problem</v-icon>
              ¡No se encontro información... Verifique que el número de
              confirmación este correcto!
            </div>
          </v-flex>
        </v-layout>

        <v-stepper-content v-for="n in 4" :key="`${n}-content`" :step="n">
          <!-- contenido que se muestra al pasar de step -->
          <v-card v-if="dataFound && !noDataFound && allInfo">
            <!--Card donde se mostrara la información-->
            <v-card>
              <v-toolbar class="primary" dark>
                <v-toolbar-Title
                  class="text-sm-display-1 text-md-h4 text-lg-h4 text-xl-h3"
                >
                  Cliente: {{ client }}
                </v-toolbar-Title>
              </v-toolbar>

              <v-list dense>
                <v-list-item-title>
                  <v-layout row wrap class="pa-3" justify-center>
                    <v-flex xs12 sm4 md4>
                      <div
                        class="primary text-sm-display-1 text-md-h4 text-lg-h4 text-xl-h3 white--text box"
                      >
                        Pedido
                      </div>

                      <div
                        class="nextBox text-sm-display-1 text-md-h5 text-lg-h5 text-xl-h4"
                      >
                        {{ pedidoId }}
                      </div>
                    </v-flex>

                    <v-flex xs12 sm3 md4>
                      <div
                        class="primary text-sm-display-1 text-md-h4 text-lg-h4 text-xl-h3 white--text box"
                      >
                        Fecha de captura
                      </div>

                      <div
                        class="nextBox text-sm-display-1 text-md-h5 text-lg-h5 text-xl-h4"
                      >
                        {{ pedidoFecha }}
                      </div>
                    </v-flex>

                    <v-flex xs12 sm5 md4>
                      <div
                        class="primary text-sm-display-1 text-md-h4 text-lg-h4 text-xl-h3 white--text box"
                      >
                        Fecha estimada de entrega
                      </div>

                      <div
                        class="nextBox text-sm-display-1 text-md-h5 text-lg-h5 text-xl-h4"
                      >
                        {{ entregaFecha }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-list-item-title>
              </v-list>

              <v-list-group color="primary">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>Detalles del pedido</v-list-item-title>

                    <v-list-item-subtitle
                      v-show="status == 'En proceso' && !estatusFact"
                    >
                      Estatus: {{ status }}</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </template>

                <v-list-item v-for="(nofact, i) in newArray" :key="i">
                  <v-layout row wrap justify-center>
                    <v-row no-gutters v-show="nofact.validacion == 'false'">
                      <v-col md="1" sm="2" xs="1" class="d-flex flex-column">
                        <v-card
                          class="pa-2 flex d-flex flex-column"
                          outlined
                          tile
                        >
                          <div class="font-weight-normal">
                            <strong>Partida</strong>
                          </div>
                          {{ nofact.partida }}
                        </v-card>
                      </v-col>

                      <v-col md="2" sm="2" xs="2" class="d-flex flex-column">
                        <v-card
                          class="pa-2 flex d-flex flex-column"
                          outlined
                          tile
                        >
                          <div class="font-weight-normal">
                            <strong>Codigo</strong>
                          </div>
                          {{ nofact.codigo }}
                        </v-card>
                      </v-col>

                      <v-col md="2" sm="2" xs="5" class="d-flex flex-column">
                        <v-tooltip top max-width="400px" nudge-bottom="15px">
                          <template v-slot:activator="{ on }">
                            <v-card
                              class="pa-2 flex d-flex flex-column"
                              outlined
                              tile
                              v-on="on"
                            >
                              <div class="font-weight-normal">
                                <strong>No. parte</strong>
                              </div>
                              {{ numParteAbreviado(nofact.numParte) }}
                            </v-card>
                          </template>
                          <span>{{ nofact.numParte }}</span>
                        </v-tooltip>
                      </v-col>

                      <v-col md="2" sm="2" xs="2" class="d-flex flex-column">
                        <v-card
                          class="pa-2 flex d-flex flex-column"
                          outlined
                          tile
                        >
                          <div class="font-weight-normal">
                            <strong>Cantidad entregada</strong>
                          </div>
                          {{ nofact.cantidadInfo }}
                        </v-card>
                      </v-col>

                      <v-col md="5" sm="4" xs="1" class="hidden-xs-only">
                        <v-tooltip top max-width="400px" nudge-bottom="15px">
                          <template v-slot:activator="{ on }">
                            <v-card
                              class="pa-2 flex d-flex flex-column"
                              outlined
                              tile
                              v-on="on"
                            >
                              <div class="font-weight-normal">
                                <strong>Descripción</strong>
                              </div>
                              {{ itemDescripcion(nofact.descripcion) }}
                            </v-card>
                          </template>

                          <span>{{ nofact.descripcion }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-layout>
                </v-list-item>
              </v-list-group>

              <v-list-group
                v-for="(child, i) in data.informacion"
                :key="i"
                v-show="child.fact_num != null"
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      Factura: {{ child.almacen }}-{{ child.fact_num }}
                    </v-list-item-title>

                    <v-list-item-subtitle v-show="child.status == 'En Proceso'">
                      Fecha de embarque: {{ child.f_embarque }}
                    </v-list-item-subtitle>

                    <v-list-item-subtitle v-show="child.status == 'Entregado'">
                      Fecha de entrega:
                      {{ child.f_entrega }}
                    </v-list-item-subtitle>

                    <v-list-item-subtitle>
                      Estatus: {{ child.status }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </template>

                <v-list-item v-for="(partidas, i) in child.doc" :key="i">
                  <v-layout row wrap justify-center>
                    <v-row no-gutters v-show="partidas.validacion == 'false'">
                      <v-col md="1" sm="2" xs="1" class="d-flex flex-column">
                        <v-card
                          class="pa-2 flex d-flex flex-column"
                          outlined
                          tile
                        >
                          <div class="font-weight-normal">
                            <strong>Partida</strong>
                          </div>
                          {{ partidas.partida }}
                        </v-card>
                      </v-col>

                      <v-col md="2" sm="2" xs="2" class="d-flex flex-column">
                        <v-card
                          class="pa-2 flex d-flex flex-column"
                          outlined
                          tile
                        >
                          <div class="font-weight-normal">
                            <strong>Codigo</strong>
                          </div>
                          {{ partidas.codigo }}
                        </v-card>
                      </v-col>

                      <v-col md="2" sm="2" xs="5" class="d-flex flex-column">
                        <v-tooltip top max-width="400px" nudge-bottom="15px">
                          <template v-slot:activator="{ on }">
                            <v-card
                              class="pa-2 flex d-flex flex-column"
                              outlined
                              tile
                              v-on="on"
                            >
                              <div class="font-weight-normal">
                                <strong>No. parte</strong>
                              </div>
                              {{ numParteAbreviado(partidas.parte) }}
                            </v-card>
                          </template>

                          <span>{{ partidas.parte }}</span>
                        </v-tooltip>
                      </v-col>

                      <v-col md="2" sm="2" xs="2" class="d-flex flex-column">
                        <v-card
                          class="pa-2 flex d-flex flex-column"
                          outlined
                          tile
                        >
                          <div class="font-weight-normal">
                            <strong>Cantidad</strong>
                          </div>
                          {{ partidas.cantidad }} {{ partidas.tipo }}(S)
                        </v-card>
                      </v-col>

                      <v-col md="5" sm="4" xs="1" class="hidden-xs-only">
                        <v-tooltip top max-width="400px" nudge-bottom="15px">
                          <template v-slot:activator="{ on }">
                            <v-card
                              class="pa-2 flex d-flex flex-column"
                              outlined
                              tile
                              v-on="on"
                            >
                              <div class="font-weight-normal">
                                <strong>Descripción</strong>
                              </div>
                              {{ itemDescripcion(partidas.descripcion) }}
                            </v-card>
                          </template>

                          <span>{{ partidas.descripcion }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-layout>
                </v-list-item>
              </v-list-group>
            </v-card>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-container>
</template>
<script>
import _ from "underscore";

export default {
  data() {
    return {
      show: false,
      noDataFound: false,
      loading: false,
      dataFound: false,
      numPedido: "",
      crtrlventa: "",
      ctrl: 0,
      numFactura: "",
      client: "",
      pedidoId: "",
      entregaFecha: "",
      pedidoFecha: "",
      embarqueFecha: "",
      showInfo: false,
      facturaNum: false,
      pedidoParcial: false,
      paso0: false,
      paso1: false,
      paso2: false,
      paso3: false,
      estatusFact: false,
      allInfo: false,
      statusCodigo: "",
      status: "",
      model: {
        pedidoNum: "",
      },
      data: [],
      pedidoItems: [],
      facturados: [],
      newArray: [],
    };
  },

  props: {
    pedidoNum: { type: Number },
    sendSnack: { type: Function },
  },

  methods: {
    getPedidoInfocomplemento: async function (pedidonum) {
      var vm = this;
      await this.getPedidoInfo(pedidonum).then(async (info) => {
        vm.client = info.client;
        vm.pedidoFecha = info.f_Pedido;
        vm.entregaFecha = info.f_Promesa;
        vm.pedidoId = info.pedidoId;

        var informacion = info.informacion.map(async (pedido) => {
          await vm.getfacturaInfo(pedido.docId).then((doc) => {
            vm.status = pedido.status;
            pedido.doc = doc;
            return pedido;
          });
          if (pedido.factura == false) {
            vm.estatusFact = true;
          }
        });
        await Promise.all(informacion);
        vm.newArray = await vm.getNofacturados();

        vm.data = info;
      });
      vm.loading = false;
      vm.allInfo = true;
    },

    getPedidoInfo: async function (pedidoNum) {
      this.loading = true;
      this.clearFields();
      var baseURL = "https://market.risoul.com.mx/api/pedido/tracking";
      var vm = this;
      return await this.$http({
        method: "get",
        url: `${baseURL}/${pedidoNum}`,
      }).then(
        async (response) => {
          var info =
            response.body.info == 0
              ? ((vm.noDataFound = true), (vm.loading = false))
              : response.body.info;
          let rows = response.body.info;

          vm.dataFound = true;
          var pedido = {
            informacion: rows.map((row) => {
              return {
                f_embarque: row.FECHA_EMBARQUE,
                f_entrega: row.FECHA_ENTREGA,
                factura: !!!row.ID_DOC,
                entregado: !!!row.FECHA_ENTREGA,
                status: vm.checkStatus(
                  row.ESTATUS_ENVIO,
                  row.FECHA_EMBARQUE,
                  row.FECHA_ENTREGA,
                  row.ID_NOTA_CREDITO,
                ),
                docId: row.ID_DOC,
                fact_num: row.FACTURA_NUM,
                almacen: row.ALMACEN,
              };
            }),
          };
          pedido.pedidoId = rows[0].PEDIDO;
          pedido.client = rows[0].CLIENTE;
          pedido.f_Pedido = rows[0].FECHA_PEDIDO;
          pedido.f_Promesa = rows[0].FECHA_PROMESA;
          pedido.ctrlVenta = rows[0].ID_CTRL_VENTA;
          await vm.getItemsInfo(rows[0].ID_CTRL_VENTA);

          return pedido;
        },
        (error) => {
          this.loading = false;
          this.sendSnack(
            `Hubo un problema al obtener la información del número de pedido ingresado.`,
          );
          console.error(error);
        },
      );
    },

    getfacturaInfo: async function (idDoc) {
      var baseURL = "https://market.risoul.com.mx/api/pedido/factura";
      var vm = this;
      if (idDoc == null) {
        idDoc = 0;
      }
      return await this.$http({
        method: "get",
        url: `${baseURL}/${idDoc}`,
      }).then(
        (response) => {
          var info = [];
          var fact =
            response.body.fact == 0
              ? (vm.noDataFound2 = true)
              : response.body.fact;
          let rows = response.body.fact;
          vm.loading2 = false;
          info = rows.map((row) => {
            var informacion = {
              partida: row.DET,
              codigo: row.CODI,
              descripcion: row.DESCRIP,
              cantidad: row.CANT,
              tipo: row.MEDI,
              parte: row.PARTE,
              validacion: row.VALI,
            };
            vm.facturados.push(informacion);
            return informacion;
          });

          return info;
        },
        (error) => {
          this.sendSnack(
            `Hubo un problema al obtener la información del número de pedido ingresado.`,
          );
          console.error(error);
        },
      );
    },

    getItemsInfo: async function (idcrtlven) {
      this.crtrlventa = "";
      this.numPedido = "";
      this.pedidoItems = [];
      var baseURL = "https://market.risoul.com.mx/api/pedido/items";
      var vm = this;
      return await this.$http({
        method: "get",
        url: `${baseURL}/${idcrtlven}`,
      }).then(
        (response) => {
          var info = [];
          var arti =
            response.body.arti == 0
              ? "No se encontro información del número de pedido ingresado"
              : response.body.arti;
          let rows = response.body.arti;

          rows.map((row) => {
            if (vm.numPedido == "") {
              vm.crtrlventa = row.ALMA + "-" + row.FOLI;
              vm.numPedido = row.PEDI;
            }
            var informacion = {
              partida: row.PART,
              codigo: row.CODI,
              descripcion: row.DESCRIP,
              cantidad: row.CANT,
              tipo: row.MEDI,
              numParte: row.PARTE,
              validacion: row.VALI,
            };

            vm.pedidoItems.push(informacion);
            info.push(informacion);
          });
          return info;
        },
        (error) => {
          this.sendSnack(
            `Hubo un problema al obtener la información del número de pedido ingresado.`,
          );
          console.error(error);
        },
      );
    },

    getNofacturados: async function () {
      let vm = this;
      var prodEntregados = _.map(this.pedidoItems, (i) => {
        var objs = _.filter(vm.facturados, { codigo: i.codigo });

        if (objs.length > 0) {
          var total = _.reduce(
            objs,
            (acumulador, obj) => {
              return acumulador + Number(obj.cantidad);
            },
            0,
          );
          objs.cantidadInfo = `${total} de ${i.cantidad} ${i.tipo}(S)`;
          if (total != i.cantidad) {
            vm.pedidoParcial = true;
          }
          objs.partida = i.partida;
          objs.codigo = i.codigo;
          objs.numParte = i.numParte;
          objs.descripcion = i.descripcion;
          objs.validacion = i.validacion;

          return objs;
        } else {
          vm.pedidoParcial = true;
          i.cantidadInfo = `0 de ${i.cantidad} ${i.tipo}(S)`;

          return i;
        }
      });

      return prodEntregados;
    },

    itemDescripcion: function (name) {
      if (name.length > 70) name = `${name.substring(0, 70)}...`;
      return name;
    },

    numParteAbreviado: function (number) {
      if (number.length > 9) number = `${number.substring(0, 9)}  ...`;
      return number;
    },

    productDetail(sku) {
      return `#/productDetail/${sku}`;
    },

    checkStatus: function (estatus, embarque, entrega, idnota) {
      if (estatus == null || estatus == "0") {
        estatus = "En proceso";
        this.paso0 = true;
        this.paso1 = true;
        this.paso2 = false;
        this.paso3 = false;
      }
      if (
        embarque != null &&
        entrega == null &&
        (estatus == "B" || estatus == "0")
      ) {
        estatus = "En ruta";
        this.paso0 = true;
        this.paso1 = true;
        this.paso2 = true;
        this.paso3 = false;
      }
      if (estatus == "L") {
        estatus = "Entregado";
        this.paso0 = true;
        this.paso1 = true;
        this.paso2 = true;
        this.paso3 = true;
      }
      if (estatus == "R") {
        estatus = "Reenviado";
        this.paso0 = true;
        this.paso1 = true;
        this.paso2 = false;
        this.paso3 = false;
      }
      if (idnota != "0" && entrega == "") {
        estatus = "No recibida";
      }
      return estatus;
    },

    clearFields: function () {
      this.noDataFound = false;
      this.dataFound = false;
      this.data = [];
      this.facturados = [];
      this.noFacturados = [];
      this.pedidoItems = [];
      this.newArray = [];
      this.showInfo = false;
      this.client = "";
      this.pedidoId = "";
      this.pedidoFecha = "";
      this.entregaFecha = "";
      this.embarqueFecha = "";
      this.status = "";
      (this.pedidoParcial = false),
        (this.estatusFact = false),
        (this.allInfo = false),
        (this.paso0 = false);
      this.paso1 = false;
      this.paso2 = false;
      this.paso3 = false;
      this.statusCodigo = "";
    },

    verifyPedidoNum: function () {
      if (this.$route.query.np) {
        this.model.pedidoNum = this.$route.query.np;
        this.getPedidoInfocomplemento(this.model.pedidoNum);
      }
    },
  },

  computed: {},

  watch: {
    ctrl: function (val) {
      this.getItemsInfo(val);
    },
  },

  created() {
    this.verifyPedidoNum();
  },

  mounted() {},
};
</script>

<style scoped>
.dividerStep {
  background-color: grey;
}

.stepDivide1 {
  background-color: rgb(12, 12, 182);
}

.elevation-5 tr th:first-of-type,
td:first-of-type {
  background-color: blue;
}

.prueba {
  margin-left: 3%;
}

.pb-0 {
  margin-top: -15%;
}

.infor {
  border-left: 4px solid #091dd5;
}
.box {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.boxs {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.b {
  align-items: center;
  justify-content: center;
}
.nextBox {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.child.Entregado {
  border-left: 4px solid chartreuse;
}
.child.ruta {
  border-left: 4px solid rgb(236, 182, 64);
}
.child.proceso {
  border-left: 4px solid rgb(64, 110, 236);
}
.child.Reenviado {
  border-left: 4px solid rgb(235, 70, 29);
}
.tile:active {
  background: yellow;
}
</style>
